import { render, staticRenderFns } from "./CardAdvanceChat.vue?vue&type=template&id=bd1f5bd0"
import script from "./CardAdvanceChat.vue?vue&type=script&lang=js"
export * from "./CardAdvanceChat.vue?vue&type=script&lang=js"
import style0 from "./CardAdvanceChat.vue?vue&type=style&index=0&id=bd1f5bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports